import refs from '../helpers/refs'

class CExpandableContent {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    this.$root.querySelectorAll('[data-button]').forEach((node) => {
      node.addEventListener('click', () => {
        node.parentNode.classList.toggle('active')
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-expandable-content')
    .forEach(el => new CExpandableContent(el))
})
